{
  "pageTitle": "Qoidalar va siyosatlar",
  "pageIntro": "Quyidagi hujjatlar VBB PLAY uchun qoralama. Kompaniya nomi, litsenziya va qo‘llaniladigan huquq egasi tasdiqlamaguncha ishlab chiqarishga tayyor emas.",
  "draftBadge": "QORALAMA — tasdiq kutilmoqda",
  "backToList": "Barcha qoidalarga qaytish",
  "updatedLabel": "Versiya",
  "version": "0.2-draft",
  "footerNote": "Bu tasdiqlangan yuridik matn emas. Jonli saytga faqat alohida ruxsatdan keyin chiqariladi.",
  "navTitle": "Qoidalar",
  "categories": {
    "terms": {
      "title": "Foydalanish qoidalari",
      "summary": "Hisob ochish, platformadan foydalanish va asosiy majburiyatlar.",
      "sections": [
        {
          "heading": "1. Umumiy",
          "body": "VBB PLAY onlayn o‘yin va bog‘liq xizmatlar platformasi. Ro‘yxatdan o‘tish yoki foydalanish ushbu qoidalarni qabul qilishni anglatadi. Rasmiy kompaniya nomi, ro‘yxatdan o‘tish mamlakati va litsenziya egasi tasdiqlagandan keyin qo‘shiladi."
        },
        {
          "heading": "2. Hisob",
          "body": "Har bir foydalanuvchida faqat bitta shaxsiy hisob bo‘lishi mumkin. Kirish ma’lumotlari maxfiyligi sizning javobgarligingizda."
        },
        {
          "heading": "3. Yosh va muvofiqlik",
          "body": "Xizmat faqat qonuniy yoshga yetganlar uchun. Tekshiruv talab qilinishi mumkin."
        },
        {
          "heading": "4. Taqiqlangan harakatlar",
          "body": "Firibgarlik, avtomatlashtirishni suiiste’mol qilish va noqonuniy faoliyat taqiqlanadi."
        },
        {
          "heading": "5. Xizmat o‘zgarishi",
          "body": "Funksiyalar va katalog ogohlantirish bilan o‘zgartirilishi yoki vaqtincha to‘xtatilishi mumkin."
        },
        {
          "heading": "6. Aloqa",
          "body": "Nizolar va savollar uchun Jonli yordamdan foydalaning."
        }
      ]
    },
    "privacy": {
      "title": "Maxfiylik siyosati",
      "summary": "Shaxsiy ma’lumotlarni yig‘ish, saqlash va foydalanish.",
      "sections": [
        {
          "heading": "1. Qanday ma’lumotlar",
          "body": "Hisob, aloqa, to‘lov metama’lumotlari, texnik jurnallar va yordam yozishmalari qayta ishlanishi mumkin."
        },
        {
          "heading": "2. Maqsad",
          "body": "Ma’lumotlar hisob boshqaruvi, xavfsizlik, to‘lovlar, yordam va qonuniy majburiyatlar uchun ishlatiladi."
        },
        {
          "heading": "3. Ulashish",
          "body": "Ma’lumotlar sotilmaydi; to‘lov/o‘yin provayderlari va qonun bo‘yicha organlarga berilishi mumkin."
        },
        {
          "heading": "4. Saqlash muddati",
          "body": "Xizmat va qonun uchun zarur muddat saqlanadi, keyin o‘chiriladi yoki anonimlashtiriladi."
        },
        {
          "heading": "5. Huquqlaringiz",
          "body": "Yordam orqali kirish, tuzatish yoki o‘chirish so‘rovini yuborishingiz mumkin."
        },
        {
          "heading": "6. Xavfsizlik",
          "body": "Texnik va tashkiliy choralari qo‘llaniladi; mutlaq xavfsizlik yo‘q."
        }
      ]
    },
    "bonuses": {
      "title": "Bonus qoidalari",
      "summary": "Bonuslar, promo kodlar va omad g‘ildiragi shartlari.",
      "sections": [
        {
          "heading": "1. Umumiy",
          "body": "Bonuslar kampaniya shartlari va hisob holatiga bog‘liq."
        },
        {
          "heading": "2. Haqiqiy va bonus balans",
          "body": "Mablag‘lar alohida hisoblanadi. Bonus o‘yini faqat ruxsat etilgan o‘yinlarda."
        },
        {
          "heading": "3. Veyjer",
          "body": "Aylanma talablari kampaniyada ko‘rsatiladi; bajarilmasa bonus bekor qilinishi mumkin."
        },
        {
          "heading": "4. Suiiste’mol",
          "body": "Ko‘p hisob yoki shartlarni chetlab o‘tish bonus bekor qilinishiga olib kelishi mumkin."
        },
        {
          "heading": "5. O‘zgarishlar",
          "body": "Kampaniyalar to‘xtatilishi yoki o‘zgartirilishi mumkin."
        }
      ]
    },
    "payments": {
      "title": "Depozit va yechib olish",
      "summary": "To‘lov usullari, limitlar va tekshiruv.",
      "sections": [
        {
          "heading": "1. Depozit",
          "body": "Faqat faol usullar qabul qilinadi. Noto‘g‘ri tarmoq/rekvizit/summa kechikish yoki yo‘qotishga olib kelishi mumkin."
        },
        {
          "heading": "2. Yechib olish",
          "body": "So‘rovlar tekshirilishi mumkin; KYC talab qilinishi mumkin."
        },
        {
          "heading": "3. Valyuta",
          "body": "Asosiy valyuta platformada ko‘rsatilgan valyuta."
        },
        {
          "heading": "4. Cheklar",
          "body": "Ba’zi usullarda chek yoki qo‘shimcha tasdiq kerak. Soxta hujjat taqiqlanadi."
        },
        {
          "heading": "5. Qaytarish",
          "body": "Xato operatsiyalar yordam va hamkorlar orqali faktlar asosida ko‘riladi."
        }
      ]
    },
    "responsible": {
      "title": "Mas’uliyatli o‘yin",
      "summary": "O‘zini cheklash va zararli xulqning oldini olish.",
      "sections": [
        {
          "heading": "1. Tamoyil",
          "body": "O‘yin — ko‘ngilocharlik. Yutuq kafolatlanmaydi."
        },
        {
          "heading": "2. Vositalar",
          "body": "Sovutish, o‘zini cheklash va yopish so‘rovi mavjud bo‘lishi mumkin."
        },
        {
          "heading": "3. Yordam",
          "body": "Xavf sezsangiz, professional yordam oling."
        },
        {
          "heading": "4. Voyaga yetmaganlar",
          "body": "Ishtirok taqiqlanadi; bunday hisoblar yopiladi."
        }
      ]
    },
    "kyc": {
      "title": "Hisobni tasdiqlash (KYC)",
      "summary": "Shaxs va aloqani tekshirish.",
      "sections": [
        {
          "heading": "1. Qachon",
          "body": "Yechib olish, katta summa, xavf yoki qonun bo‘yicha KYC so‘ralishi mumkin."
        },
        {
          "heading": "2. Hujjatlar",
          "body": "Shaxs guvohnomasi, manzil va to‘lov isboti talab qilinishi mumkin."
        },
        {
          "heading": "3. Qayta ishlash",
          "body": "Ma’lumotlar faqat tekshiruv uchun va maxfiylik siyosati bo‘yicha saqlanadi."
        },
        {
          "heading": "4. Natija",
          "body": "Tekshiruv tugaguncha amaliyotlar cheklanishi mumkin."
        }
      ]
    },
    "aml": {
      "title": "AML va firibgarlikka qarshi",
      "summary": "Shubhali operatsiyalarning oldini olish.",
      "sections": [
        {
          "heading": "1. Maqsad",
          "body": "Platforma pul yuvish va firibgarlikning oldini olishga intiladi."
        },
        {
          "heading": "2. Monitoring",
          "body": "Operatsiyalar va xulq avtomatik va/yoki qo‘lda tekshirilishi mumkin."
        },
        {
          "heading": "3. Chora",
          "body": "Shubhada depozit/yechib olish to‘xtatilib, hisob muzlatilishi mumkin."
        },
        {
          "heading": "4. Hamkorlik",
          "body": "Foydalanuvchilar yordam so‘rovlariga o‘z vaqtida javob berishi kerak."
        }
      ]
    },
    "fairplay": {
      "title": "Adolatlilik va yosh",
      "summary": "O‘yin adolatliligi, provayder qoidalari va yosh chegarasi.",
      "sections": [
        {
          "heading": "1. Provayderlar",
          "body": "O‘yinlar uchinchi tomon provayderlari tomonidan taqdim etilishi mumkin."
        },
        {
          "heading": "2. Natijalar",
          "body": "Natijani provayder tizimi belgilaydi."
        },
        {
          "heading": "3. Yosh",
          "body": "Haqiqiy pul o‘yini faqat qonuniy yoshdagilar uchun."
        },
        {
          "heading": "4. Til",
          "body": "Provayder interfeysi faqat qo‘llab-quvvatlanadigan tillarda ko‘rsatiladi."
        }
      ]
    },
    "self_exclusion": {
      "title": "O‘zini cheklash siyosati",
      "summary": "Sovutish, o‘zini cheklash va hisobni vaqtinchalik yoki doimiy cheklash.",
      "sections": [
        {
          "heading": "1. Maqsad",
          "body": "Bu siyosat o‘yin faoliyatini to‘xtatish yoki cheklash vositalarini taqdim etadi."
        },
        {
          "heading": "2. Vositalar",
          "body": "Sovutish, o‘zini cheklash va yopish so‘rovi profil/xavfsizlik yoki Jonli yordam orqali mavjud bo‘lishi mumkin."
        },
        {
          "heading": "3. Ta’sir",
          "body": "O‘zini cheklash faol bo‘lsa, depozit, o‘yin yoki boshqa amallar cheklanishi mumkin. Muddat tugaguncha odatda olib tashlanmaydi."
        },
        {
          "heading": "4. So‘rov jarayoni",
          "body": "Yordam so‘rovlari ko‘rib chiqiladi. Shaxsni tasdiqlash talab qilinishi mumkin."
        },
        {
          "heading": "5. Mas’uliyat",
          "body": "Vositalar xavfni kamaytiradi, lekin professional yordamni almashtirmaydi."
        },
        {
          "heading": "6. Huquqiy eslatma",
          "body": "Kompaniya ma’lumotlari egasi tasdiqlagandan keyin qo‘shiladi. Bu qoralama matn."
        }
      ]
    },
    "disputes": {
      "title": "Nizolarni hal qilish siyosati",
      "summary": "To‘lov, bonus, o‘yin natijasi va hisob nizolarini ko‘rib chiqish tartibi.",
      "sections": [
        {
          "heading": "1. Qamrov",
          "body": "Depozit/yechib olish, bonus, hisob holati va o‘yin sessiyalari bo‘yicha nizo."
        },
        {
          "heading": "2. Birinchi murojaat",
          "body": "Avval Jonli yordamga yozing. So‘rov raqami, sana, summa va isbotlarni qo‘shing."
        },
        {
          "heading": "3. Tekshiruv",
          "body": "Yordam jurnallar va to‘lov/provayder ma’lumotlarini tekshirishi mumkin."
        },
        {
          "heading": "4. Muddat",
          "body": "Oddiy holatlar tezroq ko‘riladi; murakkab tekshiruvlar uzoqroq davom etishi mumkin."
        },
        {
          "heading": "5. Natija",
          "body": "Qaror faktlarga asoslanadi. Soxta hujjatlar cheklovga olib kelishi mumkin."
        },
        {
          "heading": "6. Eskalatsiya",
          "body": "Qo‘shimcha eskalatsiya yo‘li egasi tasdiqlagandan keyin qo‘shiladi. Bu qoralama matn."
        }
      ]
    }
  }
}
